import React, { useEffect, useState, useRef } from 'react';

import './index.module.less';

import FridayService from '@services/friday';
import { getDates } from '../utils';

import { Api } from '@apis/client';
import Http from '@helpers/Http';

interface ItemProps {
  value: string;
  title: string;
  onSelect: (value: string) => void;
  isSelected: boolean;
}

interface IProps {
  company?: string;
  sncode?: string;
  selectDate?: string;
  onSelectDate?: (value: string) => void;
}

const Item = (props: ItemProps) => {
  const { isSelected, title, onSelect, value } = props;

  const clickItem = () => {
    FridayService.addEvent('track_switching_time_click', { type: title });
    onSelect(value);
  }
  return (
    <span
      className="flex"
      styleName="header-date-item"
      style={isSelected ? { color: '#256EFF' } : {}}
      onClick={clickItem}
    >
      { title }
    </span>
  )
}

const DateBar = (props: IProps) => {
  const { onSelectDate, sncode, company } = props;
  const dates = useRef(getDates());
  const [selectDateItem, setSelectedDate] = useState<any>(dates.current[0].value);
  const [steps, setSteps] = useState(0);

  const getSteps = async (value?: string) => {
    const { data: result } = await Http.post(Api.GetTrajectoryV1Step,
      { sncode, queryTime: value || selectDateItem,  company: company
      }
    );
    setSteps(result);
  }
  useEffect(() => {
    onSelectDate && onSelectDate(selectDateItem);
    getSteps();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setSelectedDate(props.selectDate);
  }, [props.selectDate])

  const onSelect = (value: string) => {
    props.onSelectDate(value);
    getSteps(value);
  }

  const renderDates = () => {
    const items = dates.current.map((item: any, index: number) => {
      return (
        <Item
          key={index}
          isSelected={ item.value === selectDateItem }
          onSelect={onSelect}
          {...item}
        />
      )
    })
    return items;
  }


  const formatStepText = (num: number) => {
    return num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  }

  return (
    <div
        className="flex"
        styleName="header"
      >
        <div className="flex" styleName="header-date">
          { renderDates() }
        </div>
        <div className="flex" styleName="header-step-count">
          <div className="flex" styleName="count-title">步数：</div>
          <div styleName="count-text"> { steps ? formatStepText(steps) : 0 }</div>
        </div>
      </div>
  )
}

export default DateBar;